import React, { useEffect } from 'react';
import styled from 'styled-components';
import Layout from '../../LayoutFlow/views/App';
import { useLocation, useHistory } from 'react-router-dom';
import {
  addBrowserHistory,
  getNextPath,
  addChatboxAnswer,
  addChatboxQuestion,
} from '../../../../store';
import ChatBox from '../../../../components/ChatBox';
import QuestionBox from '../../../../components/QuestionBox';
import { useTranslation } from 'react-i18next';
import { setInsuredData } from '../store';

const LegalIncome = () => {
  const { t } = useTranslation();
  let location = useLocation();
  let history = useHistory();
  useEffect(() => {
    addBrowserHistory(location.pathname);
  }, []);

  const handleAnswer = answer => {
    addChatboxQuestion(
      t(
        'would you like the assistance of a lawyer if an employer threatens dismissal, or if you have problems with your pension scheme?',
      ),
    );
    if (answer === t('Yes')) {
      setInsuredData('income', true);
      addChatboxAnswer(t('i want the assistance of a lawyer if necessary'));
    } else {
      setInsuredData('income', false);
      addChatboxAnswer(t('i do not need the assistance of a lawyer'));
    }
    history.push(getNextPath('a'));
  };

  return (
    <Layout>
      <Container>
        <ChatBox />
        <QuestionBox
          response={res => handleAnswer(res)}
          Answer1={t('Yes')}
          Answer2={t('No')}
          dataTestId1="Yes"
          dataTestId2="No"
        >
          {t(
            'would you like the assistance of a lawyer if an employer threatens dismissal, or if you have problems with your pension scheme?',
          )}
        </QuestionBox>
      </Container>
    </Layout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-items: center;
  font-size: 2rem;
  line-height: 2.6rem;
  position: relative;

  & span {
    font-weight: bold;
  }

  & div:first-child {
    z-index: 10;
  }
`;

export default LegalIncome;
